import type { ContentType } from "@prisma/client"
import type {
  Daily,
  Industry,
  Innovation,
  Macrotrend,
  Megatrend,
  Region,
  Report,
  ReportType,
  Stat,
  Subtrend,
} from "@prisma/client"
import { liteClient as algoliasearch } from "algoliasearch/lite"
import insights from "search-insights"

export const searchClient = algoliasearch("529EN77NHF", "403bef2b3323f54c5b907b91fc6923e0")

export type AlgoliaIndex =
  | "innovations"
  | "subtrends"
  | "megatrends"
  | "macrotrends"
  | "industries"
  | "reports"
  | "daily"
  | "stats"

insights("init", { appId: "529EN77NHF", apiKey: "403bef2b3323f54c5b907b91fc6923e0" })

export { insights }

export function identifyUser(userId: string) {
  insights("setUserToken", userId)
}

// controlled from algolia dashboard
export type AlgoliaInnovation = { objectID: string } & Pick<
  Innovation,
  "title" | "brand" | "businessGoals" | "cover" | "slug" | "description"
> & { industry?: string; publishedAt: number }

export type AlgoliaSubtrend = { objectID: string } & Pick<
  Subtrend,
  "title" | "slug" | "subTitle" | "definition" | "description" | "iconImage"
> & { publishedAt: number }

export type AlgoliaMegatrend = { objectID: string } & Pick<
  Megatrend,
  "title" | "slug" | "subTitle" | "definition" | "description" | "iconImage" | "color"
> & { publishedAt: number }

export type AlgoliaMacrotrend = { objectID: string } & Pick<
  Macrotrend,
  "title" | "slug" | "subTitle" | "description" | "icon"
> & { publishedAt: number }

export type AlgoliaIndustry = { objectID: string } & Pick<Industry, "title" | "slug" | "description" | "iconImage"> & {
    publishedAt: number
  }

export type AlgoliaStat = { objectID: string } & Pick<Stat, "title" | "subTitle" | "description" | "source" | "comments"> & {
    regions: Pick<Region, "title" | "slug">[]
    industries: Pick<Industry, "title" | "slug">[]
    publishedAt: number
  }

export type AlgoliaReport = { objectID: string } & Pick<
  Report,
  "title" | "types" | "cover" | "description" | "downloadPdf" | "downloadPpt"
> & { publishedAt: number; type: ReportType }

export type AlgoliaDaily = { objectID: string } & Pick<Daily, "slug" | "title" | "type" | "description"> & {
    cover: string | null
    publishedAt: number
  }

export type AlgoliaContent = Exclude<ContentType, "TOPIC">

export const ContentToIndex: Record<AlgoliaContent, string> = {
  DAILY: "daily",
  INDUSTRY: "industries",
  INNOVATION: "innovations",
  SUBTREND: "subtrends",
  MEGATREND: "megatrends",
  MACROTREND: "macrotrends",
  REGION: "regions",
  REPORT: "reports",
  STAT: "stats",
  GENERATION_RESULT: "generations",
}
